import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../../styles';

const useStyles = makeStyles(() => ({
  inputContainer: {
    width: '100%',
    height: 56,
    color: variables.richBlack,
    backgroundColor: variables.greyLight,
    borderRadius: 8,
    // marginTop: 6,
    '&.MuiInput-root': {
      border: 'none',
    },
    '&::before': {
      display: 'none',
    },
    '& $selectRoot:focus, &.Mui-focused $selectRoot': {
      border: '1px solid black',
    },
    '& $selectRoot': {
      padding: '16px',
      textAlign: 'start',
      border: 0,
      borderRadius: 8,
      height: 'auto',
    },
    '& .MuiSelect-root': {
      backgroundColor: variables.greyLight,
    },
  },
  selectIcon: {
    left: 'unset',
    right: 7,
  },
  inputError: {
    borderColor: variables.red,
  },
  errorDescription: {
    display: 'flex',
    color: variables.red,
  },
}));

export default useStyles;
